import { createContext, useContext, useMemo, useState } from 'react';

interface BlockEditorContextValue {
  isEditMode: boolean;
  rootNodeId: string;
  isDraggingExternal: boolean;
  setIsDraggingExternal: (isDragging: boolean) => void;
}

const BlockEditorContext = createContext<BlockEditorContextValue>({
  isEditMode: false,
  rootNodeId: 'ROOT',
  isDraggingExternal: false,
  setIsDraggingExternal: () => {},
});

export function useIsBlockEditorEditMode(): boolean {
  return useContext(BlockEditorContext).isEditMode;
}

export function useIsDraggingExternal() {
  const { isDraggingExternal, setIsDraggingExternal } =
    useContext(BlockEditorContext);
  return { isDraggingExternal, setIsDraggingExternal };
}

export interface BlockEditorProviderProps {
  isEditMode: boolean;
  rootNodeId?: string;
  children: React.ReactNode;
}

export function BlockEditorProvider({
  isEditMode,
  rootNodeId = 'ROOT',
  children,
}: BlockEditorProviderProps) {
  const [isDraggingExternal, setIsDraggingExternal] = useState(false);

  const value = useMemo(
    () => ({
      isEditMode,
      rootNodeId,
      isDraggingExternal,
      setIsDraggingExternal,
    }),
    [isEditMode, rootNodeId, isDraggingExternal]
  );

  return (
    <BlockEditorContext.Provider value={value}>
      {children}
    </BlockEditorContext.Provider>
  );
}
